module.exports = __webpack_public_path__ + "img/logo.d2a7d7e3.jpg";